import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';

import { ContextMenuItem, PredicateFn } from '../../models/context-menu-model';
import { isNullOrUndefined } from '@core';

@Component({
    selector: 'inf-table-row-menu-item',
    template: `
    <mat-menu #menu>
      <ng-container *ngFor="let menu of items">
        <button
          mat-menu-item
          type="button"
          class="button-menu"
          [disabled]="checkPredicate(menu.disabled, false)"
          *ngIf="!menu?.submenu && !menu?.divider; else branch"
          (click)="menuButton_OnClick(menu)">
          <mat-icon fontSet="material-icons-outlined">{{ menu.icon }}</mat-icon>
          <span>{{ menu.text }}</span>
        </button>
        <mat-divider *ngIf="menu?.divider"></mat-divider>
        <ng-template #branch>
          <button mat-menu-item type="button" class="button-menu" *ngIf="!menu?.divider" [matMenuTriggerFor]="innerPanel.menu">
            <mat-icon fontSet="material-icons-outlined">{{ menu.icon }}</mat-icon>
            <span>{{ menu.text }}</span>
          </button>
          <mat-divider *ngIf="menu?.divider"></mat-divider>
          <inf-table-row-menu-item #innerPanel [row]="row" [items]="menu.submenu" (rowActionChange)="menuButton_OnClick($event)"></inf-table-row-menu-item>
        </ng-template>
      </ng-container>
    </mat-menu>
  `,
    styles: [
        `
      @use '../../components/table-style' as tableStyle;

      @include tableStyle.context-menu;

      :host {
        display: flex;
        align-items: center;
        background-color: #fff;
        border-left: 1px solid #e5e5e5;
        //border-bottom: 1px solid #e5e5e5;

        button {
          height: 48px;
        }
      }

      .button-menu {
        display: flex;

        span {
          display: inline-block;
          width: 100%;
          text-align: left;
        }

        mat-icon {
          line-height: 48px;
          height: 48px;
          //margin: 0 5px;
          width: 40px;
        }
      }
    `
    ],
    imports: [
        CommonModule,
        MatMenuModule,
        MatIconModule,
        MatDividerModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RowMenuItemComponent<T> {
  @Input() items: ContextMenuItem[];
  @Input() row: any;
  @Output() rowActionChange: EventEmitter<ContextMenuItem> = new EventEmitter<ContextMenuItem>();

  @ViewChild('menu', { static: true }) menu: MatMenu;

  menuButton_OnClick(menu: ContextMenuItem) {
    setTimeout(() => {
      this.rowActionChange.emit(menu);
    });
  }

  checkPredicate(predicate: boolean | PredicateFn, defaultValue: boolean): boolean {
    if (isNullOrUndefined(predicate)) {
      return defaultValue;
    }

    if (typeof predicate === 'boolean' || predicate instanceof Boolean) {
      return predicate as boolean;
    }

    return predicate(this.row);
  }
}
